import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'phone'
})
export class PhonePipe implements PipeTransform {
    transform(rawNum) {

        if (!rawNum) { return ''; }

        const value = rawNum.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return rawNum;
        }

        let country;
        let city;
        let no;

        switch (value.length) {
            case 11:
                country = value[0];
                city = value.slice(1, 4);
                no = value.slice(4);
                break;

            default:
                return rawNum;
        }

        no = no.slice(0, 3) + ' ' + no.slice(3, 5) + ' ' + no.slice(5);

        return (country + ' (' + city + ') ' + no).trim();
    }
}
